import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import AddSupplier from './components/AddSupplier';
import '../../styles/products.scss';

const SupplierEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier le Fournisseur');
  }, [setTitle]);

  return (
    <div className="supplier-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddSupplier isEdit={true} supplierId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default SupplierEdit;